import { reducer as form } from 'redux-form';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import orders from './containers/Orders/reducer';
import dashboard from './containers/Dashboard/reducer';
import nav from './containers/Nav/reducer';
import menu from './containers/Menu/reducer';
import singleMenuItem from './containers/SingleMenuItem/reducer';
import app from './containers/App/reducer';
import auth from './containers/Login/reducer';
import settings from './containers/Settings/reducer';
import ratings from './containers/Ratings/reducer';

export const history = createBrowserHistory();

export const reducersList = {
  form,
  router: connectRouter(history),
  orders,
  dashboard,
  nav,
  menu,
  singleMenuItem,
  auth,
  app,
  settings,
  ratings,
};

const reducers = combineReducers(reducersList);

export default reducers;